import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import headingImg from "../../assets/HeadingImg7.svg";
import { awards } from "../../utils/constants";
import CustomHeading from "../custom/CustomHeading";

const Awards = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint:1100,
        settings:{
          slidesToShow:2.7,
          slidesToScroll:1,
        }
      }
      ,
      {
        breakpoint: 900, // Below 900px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplaySpeed: 2000,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 500, // Below 500px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div
      id="awards"
      className="flex flex-col justify-center px-[4%] sm:px-[8%] py-[6%]  sm:py-[2%] bg-[#FEEFFF]"
    >
       <CustomHeading
          text={"Awards "}
          customImg={headingImg}
          heartHeight="60px"
          heartWidth="60px"
          textColor="#d31c4f"
          smTextSize="32px"
        />
      <div className="max-w-[100%] mx-auto mt-[50px] px-4 text-left">
        <Slider {...settings} className="pb-10">
          {awards.map((member, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                maxWidth: "250px",
                border: "1px solid black ",
              }}
            >
              <img
                src={member?.image}
                alt={member.name}
                className="mx-auto pb-2 object-cover h-[250px] w-[250px]"
              />

              <h3 className="mt-4 w-[80%] mx-auto text-base text-center font-semibold text-[#D31C4F] ">
                {member.name}
              </h3>
              <p className="text-gray-500 text-sm mt-1 text-center">
                {member.role}
              </p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Awards;
